import { render, staticRenderFns } from "./CurrencyDropdown.vue?vue&type=template&id=a336d0b8"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=js"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=js"
import style0 from "./CurrencyDropdown.vue?vue&type=style&index=0&id=a336d0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCurrency: require('/var/www/tubber-new/components/global/v/currency.vue').default})
